import React from 'react';
import PropTypes from 'prop-types';
import Checkout from './Checkout';
import CheckoutGuest from './CheckoutGuest';

const CheckoutWrapper = (props) => {
  const { isUser } = props;

  return (
    <React.Fragment>
      {isUser && <Checkout {...props} />}
      {!isUser && <CheckoutGuest {...props} />}
    </React.Fragment>
  );
};

CheckoutWrapper.propTypes = {
  isUser: PropTypes.bool.isRequired,
};

export default CheckoutWrapper;



// WEBPACK FOOTER //
// ./src/components/Checkout/CheckoutWrapper.jsx